import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { useFormContext, useFieldArray } from 'react-hook-form'
import EditFacilities from '../form-components/cp-edit-facilities'
import AddIcon from 'components/material-symbol/icons/Add'
import TonalButton from 'components/empty-page-state/tonal-button'
import FormSubheader from '../create-profile-form/form-subheader'
import { useCreateProfileFieldStyles } from '../create-profile-form/field-styles'

const MAX_FACILITY_COUNT = 3
const facilitiesDescription =
  'For your coach profile to be promoted on PGA.com, you must add a facility or create a custom one. The first facility entered will be your primary facility used for location-based searches.'

const FacilitiesStep = ({ hideTitle = false }) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const { register, errors, control, setValue, watch } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'facilities',
  })

  const deleteFacility = indexToRemove => {
    remove(indexToRemove)
  }

  const handleChange = ({ target }) => {
    setValue(target.name, target.value, {
      shouldDirty: true,
      shouldValidate: true,
    })
  }

  const setFacilityFieldValue = (field, value) => {
    setValue(field, value, {
      shouldDirty: true,
      shouldValidate: true,
    })
  }

  const addNewFacility = () => {
    append({ customData: { facilityRank: fields.length + 1 } })
  }

  return (
    <Box className={hideTitle ? fieldClasses.fieldSection : undefined}>
      {!hideTitle ? (
        <Box textAlign="center" maxWidth="735px">
          <Typography variant="h4" gutterBottom>
            Add a Facility
          </Typography>
          <Typography variant="body1" gutterBottom>
            {facilitiesDescription}
          </Typography>
        </Box>
      ) : (
        <FormSubheader title="Facilities" description={facilitiesDescription} />
      )}
      <Box className={fieldClasses.fieldStack}>
        {fields.map((facility, i) => (
          <EditFacilities
            key={facility.id}
            setFieldValue={setFacilityFieldValue}
            errors={errors?.facilities && errors.facilities[i]}
            register={register}
            control={control}
            watch={watch}
            formPrefix={`facilities[${i}]`}
            isPrimary={i === 0}
            deleteMe={() => deleteFacility(i)}
            handleChange={handleChange}
            facilityIndex={i}
            addItems={setValue}
            facility={facility}
          />
        ))}
        <Box>
          <TonalButton
            type="button"
            startIcon={<AddIcon fontSize="small" />}
            onClick={addNewFacility}
            disabled={fields.length >= MAX_FACILITY_COUNT}
          >
            Add Another Facility
          </TonalButton>
        </Box>
      </Box>
    </Box>
  )
}

export default FacilitiesStep
